export default (data) => {
  let new_data = [];
  data = data.features;
  for (let datum of data) {
    new_data.push(datum.properties);
  }
  return new_data;
};
